import { useState } from 'react';
import { Switch } from 'antd';

import { usePutReviewMutation, useLazyGetComplaintsQuery } from 'store';

import { useRangePickerDate, useDirection, usePagination } from 'hooks';

import { IActiveSwitcher } from './types';

export const ActiveSwitcher = ({
  activeStatus,
  uid,
  disabled = false,
  isComplaint,
  isActive,
}: IActiveSwitcher) => {
  const [active, setActive] = useState(activeStatus);
  const [updateReview, { isLoading }] = usePutReviewMutation();

  const [trigger] = useLazyGetComplaintsQuery();
  const {
    date: { fromDate, toDate },
  } = useRangePickerDate();
  const { direction } = useDirection();
  const { page, limit } = usePagination();

  const onChange = () => {
    if (uid) {
      updateReview({
        batch: true,
        data: [{ uid }],
        active: activeStatus ? 0 : 1,
      })
        .unwrap()
        .then(() => setActive((prev) => (prev === 0 ? 1 : 0)))
        .finally(() => {
          if (isComplaint) {
            trigger({
              fromDate,
              toDate,
              page,
              limit,
              direction,
              active: isActive,
            });
          }
        });
    }
  };

  return (
    <Switch
      loading={isLoading}
      disabled={disabled}
      checkedChildren="active"
      unCheckedChildren="unactive"
      checked={!!activeStatus}
      value={!!active}
      onChange={onChange}
    />
  );
};
